import React from "react";
import Navbar from "./navbar";
import HeroComex from "./HeroComex";
import TituloTexto from "./TituloTexto";
import BeneficiosComex from "./BeneficiosComex";
import VideoComex from "./VideoComex";
import TestimoniosComex from "./TestimoniosComex";
import MarcasConfian from "./MarcasConfian";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Seo from "./Seo";

export default function Ejemplo3(props) {
  const {
    hero,
    titulo1,
    titulo2,
    clientes,
    video1,
    video2,
    experiencias,
    seo,
    beneficio,
    titulo_box_1,
    titulo_box_2,
  } = props;

  const breakpoints = {
    0: { slidesPerView: 1, spaceBetween: 10, centeredSlides: true },
    420: { slidesPerView: 1, spaceBetween: 20 },
    640: { slidesPerView: 1.2, spaceBetween: 30 },
    768: { slidesPerView: 1.5, spaceBetween: 30 },
    1024: { slidesPerView: 2, spaceBetween: 40 },
    1200: { slidesPerView: 3, spaceBetween: 30 },
    1600: { slidesPerView: 4, spaceBetween: 40 },
    2000: { slidesPerView: 4, spaceBetween: 40 },
  };

  const renderTextNode = (node, key) => {
    const { text, bold, italic } = node;

    if (!text) return null;

    let element = <span key={key}>{text}</span>;

    if (bold && italic) {
      element = (
        <strong key={key}>
          <em>{text}</em>
        </strong>
      );
    } else if (bold) {
      element = <strong key={key}>{text}</strong>;
    } else if (italic) {
      element = <em key={key}>{text}</em>;
    }

    return element;
  };

  return (
    <>
      <Seo
        metaTitle={seo[0]?.metatitle}
        metaDescription={seo[0]?.metadescription}
        metaImage={seo[0]?.metaimage?.url}
        metaKeywords={seo[0]?.metakeywords}
        canonicalURL={seo[0]?.canonicalurl}
      />
      <header>
        <Navbar />
      </header>

      <main>
        <section className=" bg-sidom-light dark:bg-sidom-blue   text-center">
          {/* Hero   */}
          {Array.isArray(hero) && hero.length ? (
            hero.map((item, index) => (
              <HeroComex
                key={item.id || index}
                titulo={item.titulo}
                subtitulo={item.text}
                video={item?.video?.url}
                imagen={item?.img?.formats?.thumbnail?.url || item.img?.url}
              />
            ))
          ) : (
            <HeroComex titulo="Cargando..." subtitulo="Espere un momento" />
          )}
        </section>
        {/* Titulo 1  */}
        {titulo1?.length > 0 && (
          <section className=" bg-sidom-blue text-center">
            {Array.isArray(titulo1) && titulo1.length ? (
              <TituloTexto
                titulo={titulo1[0]?.titulo}
                texto={titulo1[0]?.text}
              />
            ) : (
              <TituloTexto titulo="Cargando..." texto="Cargando..." />
            )}
          </section>
        )}
        {/* Beneficios */}
        {beneficio?.length > 0 && (
          <section className=" ">
            <div className="container ">
              <h1 className="text-left text-3xl mt-[70px] md:mt-[100px] lg:mt-[90px] md:text-[40px]  lg:text-[45px] leading-tight px-2 md:px-0 lg:px-0 font-extrabold text-sidom-orange mb-8">
                {titulo_box_1 &&
                titulo_box_1.titulo &&
                Array.isArray(titulo_box_1.titulo) &&
                titulo_box_1.titulo[0]?.children
                  ? titulo_box_1.titulo[0].children.map((child, index) =>
                      renderTextNode(child, index)
                    )
                  : null}
              </h1>
            </div>
            <div className="relative container mb-[70px] md:mb-[100px] lg:mb-[90px]">
              <Swiper
                spaceBetween={30}
                speed={8000}
                autoplay={{
                  delay: 1,
                  disableOnInteraction: false,
                  reverseDirection: true,
                }}
                centeredSlides={true}
                onSwiper={(swiper) => swiper.slideTo(0, 0)}
                modules={[Autoplay, Pagination, Navigation]}
                breakpoints={breakpoints}
                className="mySwiper"
              >
                {beneficio.map((item, index) => (
                  <SwiperSlide key={item.id}>
                    <BeneficiosComex
                      key={item.id || index}
                      icon={
                        item.icon?.formats?.thumbnail?.url || item.icon?.url
                      }
                      titulo={item.titulo}
                      subtitulo={item.subtitulo}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </section>
        )}
        {/* Titulo 2  */}
        {titulo2?.length > 0 && (
          <section className=" bg-sidom-blue text-center">
            {Array.isArray(titulo2) && titulo2.length ? (
              <TituloTexto
                titulo={titulo2[0]?.titulo}
                texto={titulo2[0]?.text}
              />
            ) : (
              <TituloTexto titulo="Cargando..." texto="Cargando..." />
            )}
          </section>
        )}
        {/* Video 1 */}
        {video1?.length > 0 && (
          <section className=" bg-sidom-orange text-center">
            {Array.isArray(video1) && video1.length ? (
              <VideoComex
                key={video1[0].id}
                video={video1[0].video?.url}
                controls={video1[0]?.control}
                autoPlay={video1[0]?.autoplay}
                muted={video1[0]?.muted}
                loop={video1[0]?.loop}
              />
            ) : (
              <div className="text-sidom-orange bg-sidom-blue text-center py-20">
                Cargando video...
              </div>
            )}
          </section>
        )}
        {/* testimonios  */}
        {Array.isArray(experiencias) && experiencias.length > 0 && (
          <section className="mb-[100px]">
            <TestimoniosComex
              testimonios={experiencias}
              titulo={titulo_box_2}
            />
          </section>
        )}
        {/* Clientes */}
        {Array.isArray(clientes) && clientes.length > 0 && (
          <section className="mt-[70px] md:mt-[100px] lg:mt-[90px] ">
            <div className="  text-center ">
              <MarcasConfian
                key={clientes[0].id || clientes[0].index}
                titulo={clientes[0].titulo}
                marcas={clientes[0].img}
              />
            </div>
          </section>
        )}
        {/* Video 2 */}
        {Array.isArray(video2) && video2.length > 0 && (
          <section className="bg-sidom-orange/10 text-center">
            <VideoComex
              key={video2[0].id}
              video={video2[0].video?.url}
              controls={video2[0]?.control}
              autoPlay={video2[0]?.autoplay}
              muted={video2[0]?.muted}
              loop={video2[0]?.loop}
            />
          </section>
        )}
      </main>
    </>
  );
}
